(function($){


    /////////////////////////////////////-+++-
    // Responsive resize utility function
    // fire something after the event has ended, often used for at the end of a window resize.
    // via http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed

        var waitForFinalEvent = (function () {
            var timers = {};
            return function (callback, ms, uniqueId) {
                if (!uniqueId) {
                    uniqueId = "Don't call this twice without a uniqueId";
                }
                if (timers[uniqueId]) {
                    clearTimeout (timers[uniqueId]);
                }
                timers[uniqueId] = setTimeout(callback, ms);
            };
        })();

        //sample usage:
        // $(window).resize(function () {
        //     waitForFinalEvent(function(){
        //       alert('Resize...');
        //       //...
        //     }, 500, "some unique string");
        // });

    /////////////////////////////////////-+++-
    // Fitvids
    // this plugin makes all videos (iframes) responsive inside the main content area
    // relies on jquery.fitvids plugin
        $('#main').fitVids({
          customSelector: 'iframe[src*="facebook"]'
        });


    /////////////////////////////////////-+++-
    // Fixing widows and orphans
    // Keeps lines from breaking in odd places
        $('.short-stack-teaser__description p, .header__fly-out p, .hero__title, .filmstrip__title, .flexible-promo__title-inside, .filmstrips__intro p, .pageheader__description p, .waffle__center-promo-text p, .timeline__description p').widowFix();


    /////////////////////////////////////-+++-
    // Flickity carousel for Top billing sponsors
    // If there are more then 3 sponsors, deploy a carousel

        // only fire the carousel if there are more then 3 items
        if ( $('.top-billing-sponsors__cell').length > 3 ) {

            $('.top-billing-sponsors__nav').flickity({
              // options
              cellAlign: 'left',
              pageDots: false,
              groupCells: true
            });
        }


    /////////////////////////////////////-+++-
    // Flickity carousel for special thanks sponsors and recommended by
    // If there are more then 1 sponsors, deploy a carousel

        if( $('.sponsor-thanks__list-nav').length ) {
            $('.sponsor-thanks__list-nav').flickity({
              // options
              cellAlign: 'center',
              pageDots: false,
              imagesLoaded: true
            });
        }

    /////////////////////////////////////-+++-
    // Flickity carousel for filmstrips.
    // 4 visable in main content area

        if( $('.filmstrip__nav').length ) {
            $('.filmstrip__nav').flickity({
              // options
              contain: true,
              pageDots: false,
              groupCells: true,
              imagesLoaded: true
            });
        }

    /////////////////////////////////////-+++-
    // Flickity carousel for timeline filmstrips
    // 4 visable in main content area

        // if( $('.timeline__filmstrip-nav').length ) {
        //     $('.timeline__filmstrip-nav').flickity({
        //       // options
        //       contain: true,
        //       pageDots: false,
        //       groupCells: true,
        //       imagesLoaded: true
        //     });
        // }

        // chosen multiselect on select refine dropdowns on timeline
        $(".timeline__refine-group select").chosen();

        // being able to drag or slide the date to adjust the timeline filmstrip

        // $('.timeline__filmstrip-nav').imagesLoaded( function() {
        //     new Dragdealer('timeline-slider', {
        //       animationCallback: function(x, y) {
        //         $('#timeline-slider .value').text(Math.round(x * 100));
        //       }
        //     });
        // });

    /////////////////////////////////////-+++-
    // Flickity carousel for partners on the homepage

        if( $('.partner-carousel__nav').length ) {
            $('.partner-carousel__nav').flickity({
              // options
              cellAlign: 'center',
              initialIndex: 4,
              pageDots: false,
              imagesLoaded: true
            });
        }


    /////////////////////////////////////-+++-
    // Flickity carousel for testimonials on the homepage

        if( $('.testimonial-carousel__nav').length ) {
            $('.testimonial-carousel__nav').flickity({
              // options
              cellAlign: 'center',
              initialIndex: 2,
              pageDots: false,
              imagesLoaded: true
            });
        }

    ///////////////////////////////////////-+++-
    // Flickity Carousel for the gallery component

        if( $('.gallery').length ) {

          $('.gallery').each(function () {

            var $gallery = $(this);

            var $carousel = $gallery.find('.gallery__cells').flickity({
                // options
                adaptiveHeight: true,
                contain: true,
                imagesLoaded: true,
                pageDots: false,
                imagesLoaded: true
            });

            function onLoadeddata( event ) {
                var cell = $carousel.flickity( 'getParentCell', event.target );
                $carousel.flickity( 'cellSizeChange', cell && cell.element );
              }

              $carousel.find('video').each( function( i, video ) {
                $( video ).on( 'loadeddata', onLoadeddata );
              });

            // Flickity instance
            var flkty = $carousel.data('flickity');
            // elements
            var $cellButtonGroup = $gallery.find('.gallery__nav');
            var $cellButtons = $cellButtonGroup.find('.gallery__nav-item');
            var $cellText = $gallery.find('.gallery__text-cell');

            // update selected cellButtons
            $carousel.on( 'select.flickity', function() {
                $cellButtons.filter('.is-selected').removeClass('is-selected');
                $cellButtons.eq( flkty.selectedIndex ).addClass('is-selected');

                $cellText.filter('.js-display').removeClass('js-display');
                $cellText.eq( flkty.selectedIndex ).addClass('js-display');
            });

            // select cell on button click
            $cellButtonGroup.on( 'click', '.gallery__nav-item', function() {
                var index = $(this).index();
                $carousel.flickity( 'select', index );
                $gallery.find('.gallery__text-cell').removeClass('js-display');
                $gallery.find('.gallery__text-cell').eq(index).addClass('js-display');
            });

          });
        }

    /////////////////////////////////////-+++-
    // Flickity carousel for single testimonal carousel that shows up on training pages

        if( $('.single-testimonial-carousel__nav').length ) {
            $('.single-testimonial-carousel__nav').flickity({
              // options
              cellAlign: 'center',
              pageDots: false,
              imagesLoaded: true,
              autoPlay: true
            });
        }

    ///////////////////////////////////////-+++-
    // height equalization for frontend design of three up cards

        if( $('.teaser-card-list').length ) {
            $('.teaser-card-list .teaser-card__image').matchHeight();
            $('.teaser-card-list .teaser-card').matchHeight();
        }

    /////////////////////////////////////-+++-
    // Move mobile things around
    // For the mobile offcanvas menu, all the elements there are cloned from the desktop layout

        // Clone fix utility function
        // then iterate over all the elements with IDs and 'for' labels and add a string to it (so we dont have duplicates)
        // function to replace 'ID' and 'for' attributes when cloning

        var clone_fix = function(mobileElements, mobileArea, mobileID) {
            $.each(mobileElements, function(index, item) {
                $(item).clone(true).appendTo(mobileArea);
            });
            $(mobileArea).find("[id!=''][id]").each(function(i, e){
                $(this).attr('id', $(this).attr('id') + mobileID);
            });
            $(mobileArea).find("[for!=''][for]").each(function(i, e){
                $(this).attr('for', $(this).attr('for') + mobileID);
            });
        };

        // $(document).ready(function() {
        //     clone_fix(['.header-search', '#free-press-newsletter', '.header-donate-full'], '#header-mobile-offcanvas__content', '--mobile');
        // });



    /////////////////////////////////////-+++-
    // quick view dialogues on the filmstrip elements
        $(document).ready(function() {
          // Clone both quickview and share when in plab.
          if ($('body.plab').length) {
            clone_fix(['.filmstrip-tile__dialogue-quickview', '.filmstrip-tile__dialogue-share'], '.filmstrips__modal-container-inside', '--modal');
          }
        });

        if ( $('.filmstrips').length ) {
          var $body = $('body');
          var $modal_container = $('.filmstrips__modal-container');

          // // Share code for plab, plab specific quickview code, plab specific share code
          $('body.plab .filmstrip-tile__toolbar-share, body.plab .filmstrip-tile__toolbar-quick-view').click(function () {
            var $item = $(this);
            $item.attr('aria-expanded', 'false');
            var id = $(this).attr('data-modal-open');
            var idmodal = '#' + id + '--modal';
            $item.closest('.filmstrips').find('.filmstrips__modal-container').addClass('js-modal-show');
            $body.addClass('js-modal-active').addClass('js-show');
            $(idmodal).addClass('js-show');
            setTimeout(function () {
              $item.closest('.filmstrips').find('.filmstrips__modal-container').addClass('js-modal-open');
            }, 100);
            // if the adjustposition flag is present, move the modal
            // so that is in the viewport
            $(idmodal).css("top", $(window).scrollTop());
            $(document).keydown(PollForEscape);
          });

          // Drupal specific Share code
          $('body.microfiche .filmstrip-tile__toolbar-share').click(function () {
              var $item = $(this);
              $item.attr('aria-expanded', 'false');
              var id = $(this).attr('data-modal-open');
              var idmodal = '#' + id + '--modal';
              var idmodal_nohash = id + '--modal';
              var nid = $item.data('nid');
              var $container = $item.closest('.filmstrips').find('.filmstrips__modal-container');
              $container.addClass('js-modal-show');
              var $inside = $container.find('.filmstrips__modal-container-inside');
              $body.addClass('js-modal-active').addClass('js-show');

              if ($(document).find(idmodal).length) {
                  // Use loaded share if we've already gotten it once.
                  $(document).find(idmodal).addClass('js-show');
                  setTimeout(function () {
                      $item.closest('.filmstrips').find('.filmstrips__modal-container').addClass('js-modal-open');
                  }, 100);
              } else {
                  // Load share via ajax since it doesn't exist already
                  var $div = $('<div class="filmstrip-tile__dialogue-share" id="' + idmodal_nohash + '" data-nid="' + nid + '" hidden>');
                  $inside.append($div.load('/node/' + nid + '/share', function () {
                      $(document).find(idmodal).addClass('js-show');
                      $(document).find(idmodal).find('.dialogue-quickview__close, .dialogue-share__close, .cover').click(closeButtonClick);
                      addthis.toolbox('.addthis_toolbox_sharing');
                      setTimeout(function () {
                          $item.closest('.filmstrips').find('.filmstrips__modal-container').addClass('js-modal-open');
                      }, 100);

                  }));
              }

              // if the adjustposition flag is present, move the modal
              // so that is in the viewport
              $(idmodal).css("top", $(window).scrollTop());
              $(document).keydown(PollForEscape);
          });

          // Drupal specific quickview code
          $('body.microfiche .filmstrip-tile__toolbar-quick-view').click(function () {
            var $item = $(this);
            $item.attr('aria-expanded', 'false');
            var id = $(this).attr('data-modal-open');
            var idmodal = '#' + id + '--modal';
            var idmodal_nohash = id + '--modal';
            var nid = $item.data('nid');
            var $container = $item.closest('.filmstrips').find('.filmstrips__modal-container');
            $container.addClass('js-modal-show');
            var $inside = $container.find('.filmstrips__modal-container-inside');
            $body.addClass('js-modal-active').addClass('js-show');
            if ($(document).find(idmodal).length) {
              // Use loaded quickview if we've already gotten it once.
              $(document).find(idmodal).addClass('js-show');
              setTimeout(function () {
                $item.closest('.filmstrips').find('.filmstrips__modal-container').addClass('js-modal-open');
              }, 100);
            } else {
              // Load quickview via ajax since it doesn't exist already
              var $div = $('<div class="filmstrip-tile__dialogue-quickview" id="' + idmodal_nohash + '" data-nid="' + nid + '" hidden>');
              $inside.append($div.load('/node/' + nid + '/quickview', function () {
                $(document).find(idmodal).addClass('js-show');
                $(document).find(idmodal).find('.dialogue-quickview__close, .dialogue-share__close, .cover').click(closeButtonClick);
                setTimeout(function () {
                  $item.closest('.filmstrips').find('.filmstrips__modal-container').addClass('js-modal-open');
                }, 100);
              }));
            }
            // if the adjustposition flag is present, move the modal
            // so that is in the viewport
            $(document).find(idmodal).css("top", $(window).scrollTop());
            $(document).keydown(PollForEscape);
          });

          // Update the AddThis URL and Title when sharing a filmstrip tile.
          $('.filmstrip-tile__toolbar-share').click(function() {
            var article = $(this).parents('article.filmstrip-tile');
            if (typeof addthis !== 'undefined' && typeof addthis.update !== 'undefined') {
              addthis.update('share', 'url', article.data('url'));
              addthis.update('share', 'title', article.data('title'));
            }
          });

          $(document).find('.dialogue-quickview__close, .dialogue-share__close, .cover').click(function() {
            $modal_container.removeClass('js-modal-open');
            $body.removeClass('js-modal-active');
            $(document).find('.filmstrip-tile__dialogue-quickview, .filmstrip-tile__dialogue-share').removeClass('js-show');
            setTimeout(function(){
              $modal_container.removeClass('js-modal-show');
            }, 500);

            // Reset AddThis.
            resetAddThis();

            // Stop listening for keypress.
            $(document).off('keydown', PollForEscape);
          });
        }
        //////////////////////////////////////////////////////
        // Timeline share start //////////////////////////////
        //////////////////////////////////////////////////////
        if ( $('.timeline').length ) {
          var $body = $('body');
          var $modal_container = $('.timeline .filmstrips__modal-container');

          // Drupal specific Timeline Event share code
          $('body.microfiche .timeline-event__share').click(function () {
            var $item = $(this);
            $item.attr('aria-expanded', 'false');
            var id = $(this).attr('data-modal-open');
            var idmodal = '#' + id + '--modal';
            var idmodal_nohash = id + '--modal';
            var nid = $item.data('nid');
            var $container = $item.closest('.timeline').find('.filmstrips__modal-container');
            $container.addClass('js-modal-show');
            var $inside = $container.find('.filmstrips__modal-container-inside');
            $body.addClass('js-modal-active').addClass('js-show');

            if ($('.timeline .filmstrips__modal-container-inside ' + idmodal).length) {
              // Use loaded share if we've already gotten it once.
              $('.timeline .filmstrips__modal-container-inside ' + idmodal).addClass('js-show');
              setTimeout(function () {
                $item.closest('.timeline').find('.filmstrips__modal-container').addClass('js-modal-open');
              }, 100);
            } else {
              // Load share via ajax since it doesn't exist already
              var $div = $('<div class="filmstrip-tile__dialogue-share" id="' + idmodal_nohash + '" data-nid="' + nid + '" hidden>');
              $inside.append($div.load('/node/' + nid + '/share', function () {
                $('.timeline .dialogue-share__title').text('Share this Event');
                $('.timeline .filmstrips__modal-container-inside ' + idmodal).addClass('js-show');
                $('.timeline .dialogue-share__close, .timeline .cover').click(closeButtonClick);
                addthis.toolbox('.addthis_toolbox_sharing');
                setTimeout(function () {
                  $item.closest('.timeline').find('.filmstrips__modal-container').addClass('js-modal-open');
                }, 100);

              }));
            }

            // if the adjustposition flag is present, move the modal
            // so that is in the viewport
            $(idmodal).css("top", $(window).scrollTop());
            $(document).keydown(PollForEscape);
          });

          // Update the AddThis URL and Title when sharing a filmstrip tile.
          $('.timeline .timeline-event__share').click(function() {
            var article = $(this).parents('article.timeline-tile');
            if (typeof addthis !== 'undefined' && typeof addthis.update !== 'undefined') {
              addthis.update('share', 'url', article.data('url'));
              addthis.update('share', 'title', article.data('title'));
            }
          });

          $('.timeline .dialogue-share__close, .timeline .cover').click(function() {
            $modal_container.removeClass('js-modal-open');
            $body.removeClass('js-modal-active');
            $('.timeline .timeline-event__share').removeClass('js-show');
            setTimeout(function(){
              $modal_container.removeClass('js-modal-show');
            }, 500);

            // Reset AddThis.
            resetAddThis();

            // Stop listening for keypress.
            $(document).off('keydown', PollForEscape);
          });
        }
        //////////////////////////////////////////////////////
        // Timeline share end ////////////////////////////////
        //////////////////////////////////////////////////////

        // close the modal if you press the 'esc' key
        var PollForEscape = function(e) {
          var escapeKeyCode = 27;
          if (e.which !== undefined && e.which === escapeKeyCode) {
            var $modal_container = $(document).find('.filmstrips__modal-container');
            $modal_container.removeClass('js-modal-open');
            $body.removeClass('js-modal-active');
            $(document).find('.filmstrip-tile__dialogue-quickview, .filmstrip-tile__dialogue-share').removeClass('js-show');

            setTimeout(function(){
              $modal_container.removeClass('js-modal-show');
            }, 500);

            // Reset AddThis.
            resetAddThis();

            // Stop listening for keypress.
            $(document).off('keydown', PollForEscape);
          }
        };

        var closeButtonClick = function(e) {
          var $modal_container = $(document).find('.filmstrips__modal-container');
          $modal_container.removeClass('js-modal-open');
          $body.removeClass('js-modal-active');
          $(document).find('.filmstrip-tile__dialogue-quickview, .filmstrip-tile__dialogue-share').removeClass('js-show');
          setTimeout(function(){
            $modal_container.removeClass('js-modal-show');
          }, 500);

          // Reset AddThis.
          resetAddThis();

          // Stop listening for keypress.
          $(document).off('keydown', PollForEscape);
        };

        // Reset the AddThis URL and Title to the main page after sharing a filmstrip tile.
        function resetAddThis() {
          var article = $('.addthis_toolbox_sharing');
          if (article.length && typeof addthis !== 'undefined' && typeof addthis.update !== 'undefined') {
            addthis.update('share', 'url', article.data('url'));
            addthis.update('share', 'title', article.data('title'));
          }
        }


  /////////////////////////////////////-+++-
    // Animating in misc things on scroll
    // this uses the library waypoints
    //

        // this is for the hero, which is special because we want to wait until
        // the hero image is loaded


        var $hero = $('.hero');
        var $flyout = $('.header__user-area .header__fly-out');
        var $flyout_close = $('.header__fly-out-close');

        if( $hero.length ) {
            $hero.imagesLoaded( function() {
                $hero.addClass('js-animate-in');

                // Exposing the sign up promo on the homepage for anonomous users
                if( $flyout.length ) {
                    setTimeout(function(){
                        $flyout.removeClass('js-closed');
                    }, 2000);

                    $flyout_close.on( 'click', function( event ) {
                        $flyout.addClass("js-closed");
                    });
                }
            });
        }

        var $home_waffle = $('.home-waffle');
        if( $home_waffle.length ) {
            $home_waffle.imagesLoaded( function() {
                $home_waffle.addClass('js-animate-in');
            });
        }


    /////////////////////////////////////-+++-
    // This is for the close/open collapsible/accordian sections on pages

        if ( $('.page-accordian__header button').length ) {
            $('.page-accordian').each( function() {

                var $accordian = $(this);
                var $accordian_header = $accordian.find('.page-accordian__header');
                var $accordian_content = $accordian.find('.page-accordian__content');
                var $accordian_button = $accordian_header.find('button');
                var $accordian_height = $accordian_content.height();
                var $accordian_height_new = $accordian_content.height();
                var isAccordianOpen;

                if ( $accordian.hasClass('js-open')) {
                    isAccordianOpen = true;
                }

                $accordian_header.on('click', 'button', function( event ) {
                    if ( isAccordianOpen ) {

                        $accordian.attr('aria-expanded', 'false');
                        $accordian_content.css('height', $accordian_height);
                        $accordian.removeClass('js-open').addClass('js-closed');

                        setTimeout(function(){
                            $accordian_content.css('height', 0);

                            setTimeout(function(){
                                $accordian_content.prop('hidden', true);
                            }, 500);
                        }, 10);

                    } else {

                        $accordian.attr('aria-expanded', 'true');
                        $accordian_content.prop('hidden', false);
                        $accordian_content.css('position', 'absolute').css('height', 'auto');
                        $accordian_content.css('height', 0);

                        setTimeout(function(){
                            $accordian_content.css('position', 'relative').css('height', $accordian_height_new);
                            setTimeout(function(){
                                $accordian.removeClass('js-closed').addClass('js-open');
                                //google.maps.event.trigger(map, 'resize');
                            }, 10);
                        }, 10);
                    }

                    isAccordianOpen = !isAccordianOpen;
                });
            });
        }


    /////////////////////////////////////-+++-
    // This is the filter of the waffle
    //


        if ( $('.waffle').length ) {
            $('.waffle').each( function(i, waffle) {
                var $waffle = $(waffle);
                var $waffle_filters = $waffle.find('.waffle__filters');
                var $waffle_filters_items = $waffle_filters.find('li');
                var $waffle_filters_item_links = $waffle_filters.find('a');
                var $waffle_tiles = $waffle.find('.waffle__list > li');
                var $waffle_tile_front = $waffle.find('.waffle-tile__front');
                var $filter = '';
                var $loadactive = '';

                $(document).ready(function() {
                    $loadactive = $waffle_filters.find('li.is-active a');
                    $filter = $loadactive.attr('data-filter');

                    if ( $filter == 'all') {
                        $waffle_tiles.addClass('js-active');
                    } else {
                        $waffle_tiles.filter('[data-filter="' + $filter + '"]').addClass('js-active');
                    }
                });

                $waffle_filters_item_links.click(function(e) {
                    e.preventDefault();
                    $waffle_filters_items.removeClass('is-active');
                    $waffle_tiles.removeClass('js-active');
                    $(e.currentTarget).parent().addClass('is-active');

                    $filter = $(e.currentTarget).attr('data-filter');

                    if ( $filter == 'all') {
                        $waffle_tiles.addClass('js-active');
                    } else {
                        $waffle_tiles.filter('[data-filter="' + $filter + '"]').addClass('js-active');
                    }
                });


                // clicking on waffle tiles themselves that are not highlighted switches the filter
                // to whichever one is associated with that waffle tile that was clicked.
                $waffle_tile_front.click(function(e) {
                    $filter = $(this).closest('li').attr('data-filter');

                    $waffle_filters_items.removeClass('is-active');
                    $waffle_tiles.removeClass('js-active');

                    $waffle_filters_item_links.filter('[data-filter="' + $filter + '"]').parent().addClass('is-active');
                    $waffle_tiles.filter('[data-filter="' + $filter + '"]').addClass('js-active');
                });
            });
        }


    /////////////////////////////////////-+++-
    // This is the filter for the short stack
    //

        if ( $('.short-stack').length ) {
            $('.short-stack').each( function(i, stack) {
                var $stack = $(stack);
                var $stack_filters = $stack.find('.short-stack__filters');
                var $stack_filters_items = $stack_filters.find('li');
                var $stack_filters_item_links = $stack_filters.find('a');
                var $stack_content_items = $stack.find('.short-stack__content-item');
                var filter = '';
                var $activeFilter = $stack_filters_items.filter('.is-active');

                $stack_filters_item_links.click(function(e) {
                    e.preventDefault();
                    $activeFilter = $( e.currentTarget );
                    if ( !$activeFilter.parent().hasClass('is-active') ) {
                        $stack_filters_items.removeClass('is-active');
                        $activeFilter.parent().addClass('is-active');
                        filter = $activeFilter.attr('data-filter');
                        $stack_content_items.addClass('js-right');
                        $stack_content_items.filter('[data-filter="' + filter + '"]').addClass('js-left').removeClass('js-right');
                        setTimeout(function(){
                            $stack_content_items.prop('hidden', true);
                            $stack_content_items.filter('[data-filter="' + filter + '"]').removeAttr('hidden');
                            setTimeout(function(){
                                $stack_content_items.filter('[data-filter="' + filter + '"]').removeClass('js-left');
                            }, 10);
                        }, 500);
                    }
                });
            });
        }

        // here is very similar code for the 'big short stack' display pattern which shows up
        // on the homepage
        if ( $('.big-short-stack').length ) {
            $('.big-short-stack').each( function(i, stack) {
                var $stack = $(stack);
                var $stack_filters = $stack.find('.big-short-stack__filters');
                var $stack_filters_items = $stack_filters.find('li');
                var $stack_filters_item_links = $stack_filters.find('a');
                var $stack_content_items = $stack.find('.big-short-stack__content-item');
                var filter = '';
                var $activeFilter = $stack_filters_items.filter('.is-active');

                $stack_filters_item_links.click(function(e) {
                    e.preventDefault();
                    $activeFilter = $( e.currentTarget );
                    if ( !$activeFilter.parent().hasClass('is-active') ) {
                        $stack_filters_items.removeClass('is-active');
                        $activeFilter.parent().addClass('is-active');
                        filter = $activeFilter.attr('data-filter');
                        $stack_content_items.addClass('js-right');
                        $stack_content_items.filter('[data-filter="' + filter + '"]').addClass('js-left').removeClass('js-right');
                        setTimeout(function(){
                            $stack_content_items.prop('hidden', true);
                            $stack_content_items.filter('[data-filter="' + filter + '"]').removeAttr('hidden');
                            setTimeout(function(){
                                $stack_content_items.filter('[data-filter="' + filter + '"]').removeClass('js-left');
                            }, 10);
                        }, 500);
                    }
                });
            });
        }

    /////////////////////////////////////-+++-
    // This is the show more button on short stacks
    //

        if ($('.short-stack').length ) {
            $('.short-stack__list').each(function (index, value) {
                $(this).find('li').slice(0,3).addClass('js-show');
            });

            $('.short-stack__footer a').on('click', function(e) {
                e.preventDefault();
                $(this).closest('.short-stack__content-item').addClass('js-all-shown');
            });
        }

    /////////////////////////////////////-+++-
    // Sticky social on pages
    // uses https://abouolia.github.io/sticky-sidebar/

        $('.page__sidebar-sticky').stickySidebar({
            topSpacing: 0,
            bottomSpacing: 85,
            innerWrapperSelector: '.page__sidebar-sticky-inside',
            containerSelector: '.page__content',
            minWidth: 70
        });

    /////////////////////////////////////-+++-
    // Exposing the search in the header
    //

        if( $('.header__search').length ) {
            var $search = $('.header__search');
            $('.header__search-trigger button').on( 'click', function() {
                $search.addClass("js-open");
                $search.find('#header-search').focus();
            });

            $('.header__search-close').on( 'click', function() {
                $search.removeClass("js-open");
            });
        }

        // for the mobile menu
        if( $('.mobile-menu__search').length ) {
            var $searchmobile = $('.mobile-menu__search');
            $('#mobile-menu-search').on( 'focus', function() {
                $searchmobile.addClass("js-open");
            });

            $('.header__search-close').on( 'click', function() {
                $searchmobile.removeClass("js-open");
            });
        }

    /////////////////////////////////////-+++-
    // Exposing the user menu for pending and subscribed users
    //

        if( $('.header__user-menu').length ) {
            $('.header__user-menu > button').on( 'click', function() {
                $(this).closest('.header__user-menu').toggleClass("js-open");
            });
        }

    /////////////////////////////////////-+++-
    // closing signup flyout on mobile
    //

        if( $('.header__fly-out.mobile').length ) {
            $('.header__fly-out.mobile .header__fly-out-close').on( 'click', function() {
                $(this).closest('.header__fly-out.mobile').addClass("js-closed");
            });
        }


    /////////////////////////////////////-+++-
    // Closing the profile alert that shows up on interior pages
    // for pending users

        if( $('.profile-alert').length ) {
            $('.profile-alert__close').on( 'click', function() {
                $(this).closest('.profile-alert').slideToggle('fast');
            });
        }


    /////////////////////////////////////-+++-
    // Opening and closing the mobile menu
    //

        if ( $('.header__mobile-menu-trigger').length ) {
            var $mobilemenu = $('.mobile-menu');

            $('.header__mobile-menu-trigger').click(function() {
                $(this).attr('aria-expanded', 'false');

                $mobilemenu.addClass('js-mobile-menu-show');
                setTimeout(function(){
                   $mobilemenu.addClass('js-mobile-menu-open');
                }, 100);

                // start listening for escape keypress
                $(document).keydown(PollForEscapeMobileMenu);
            });

            $('.mobile-menu__mobile-menu-trigger, .cover').click(function() {
                $mobilemenu.removeClass('js-mobile-menu-open');
                setTimeout(function(){
                   $mobilemenu.removeClass('js-mobile-menu-show');
                }, 500);

                // Stop listening for keypress.
                $(document).off('keydown', PollForEscapeMobileMenu);
            });

            // close the modal if you press the 'esc' key
            var PollForEscapeMobileMenu = function(e) {
                var escapeKeyCode = 27;
                if (e.which !== undefined && e.which === escapeKeyCode) {
                    $mobilemenu.removeClass('js-mobile-menu-open');
                    setTimeout(function(){
                       $mobilemenu.removeClass('js-mobile-menu-show');
                    }, 500);

                    // Stop listening for keypress.
                    $(document).off('keydown', PollForEscapeMobileMenu);
                }
            };
        }


    /////////////////////////////////////-+++-
    // Object-fit polyfill for ie11
    // Used on the special-header element
    // code via: https://medium.com/@primozcigler/neat-trick-for-css-object-fit-fallback-on-edge-and-other-browsers-afbc53bbb2c3

        if ( ! Modernizr.objectfit ) {
          $('.special-header__image').each(function () {
            var $container = $(this),
                imgUrl = $container.find('img').prop('src');
            if (imgUrl) {
              $container
                .css('backgroundImage', 'url(' + imgUrl + ')')
                .addClass('compat-object-fit');
            }
          });
        }


    /////////////////////////////////////-+++-
    // Artifact Viewer
    //

        if ( $('.artifact-viewer').length ) {
            var $av = $('.artifact-viewer');
            var $av_onpage = $av.find('.artifact-viewer__on-page');
            var $av_cine = $av.find('.artifact-viewer__cinematic');
            var $close = $av.find('.avc__close, .avc__close-mobile');
            var $av_thumbnail = $av.find('.avc__thumbnails-list figure');
            var $av_image = $av.find('.avc__image-tool');
            var $av_text = $av.find('.avc__text');
            var $av_title = $av.find('.avc__title-area');
            var $av_all = $av.find('.avc__text, .avc__title-area, .avc__thumbnails-list figure');
            var $av_count = $av.find('#av-count');
            var $av_next = $av.find('.avc__thumbnails-nav-next');
            var $av_prev = $av.find('.avc__thumbnails-nav-prev');
            var $av_show = $av.find('.avc__thumbnails-show-all');
            var $body = $('body');
            var $position = 1;
            var $total = $av_thumbnail.length;

            // this is the js to open and close the artifact viewer
            $av_onpage.on('click', function(e) {
                $av = $(this).closest('.artifact-viewer');
                $av_onpage = $av.find('.artifact-viewer__on-page');
                $av_cine = $av.find('.artifact-viewer__cinematic');
                $close = $av.find('.avc__close, .avc__close-mobile');
                $av_thumbnail = $av.find('.avc__thumbnails-list figure');
                $av_image = $av.find('.avc__image-tool');
                $av_text = $av.find('.avc__text');
                $av_title = $av.find('.avc__title-area');
                $av_all = $av.find('.avc__text, .avc__title-area, .avc__thumbnails-list figure');
                $av_count = $av.find('#av-count');
                $av_next = $av.find('.avc__thumbnails-nav-next');
                $av_prev = $av.find('.avc__thumbnails-nav-prev');
                $av_show = $av.find('.avc__thumbnails-show-all');
                $total = $av_thumbnail.length;

                $av.addClass('js-open');
                $body.addClass('js-fixed');
                $(document).on('keydown', PollForEscapeArtifact);

                if ($total <= 10) {
                    $av_cine.addClass('js-show-thumbnails');
                }

            });
            $close.on('click', function(e) {
                $av.removeClass('js-open');
                $body.removeClass('js-fixed');
            });

            // close the cinematic experience if you press the 'esc' key
            var PollForEscapeArtifact = function(e) {
                var escapeKeyCode = 27;
                if (e.which !== undefined && e.which === escapeKeyCode) {
                    $av.removeClass('js-open');
                    $body.removeClass('js-fixed');
                    $(document).off('keydown', PollForEscapeArtifact);
                }
            };

            // this is to reveal more then 10 artifacts
            $av_show.on('click', function(e) {
                $av_cine.addClass('js-show-thumbnails');
            });

            // this is the js to switch between artifacts in the same collection of artifacts
            $av_thumbnail.on('click', function(e) {
                $av_all.removeClass('active');
                $index = $av_thumbnail.index(this);
                $av_thumbnail.eq($index).addClass('active');
                $av_image.eq($index).addClass('active');
                $av_text.eq($index).addClass('active');
                $av_title.eq($index).addClass('active');
                $position = $index + 1;
                $av_count.html($position);
            });

            $av_next.on('click', function(e) {
                if ($position < $total) {
                    $av_all.removeClass('active');
                    $av_thumbnail.eq($position).addClass('active');
                    $av_image.eq($position).addClass('active');
                    $av_text.eq($position).addClass('active');
                    $av_title.eq($position).addClass('active');
                    $position = $position + 1;
                    $av_count.html($position);
                    $(this).trigger('avc:navigate', [$position - 1]);
                }
            });

            $av_prev.on('click', function(e) {
                if ($position > 1) {
                    $position = $position - 1;
                    $av_all.removeClass('active');
                    $av_thumbnail.eq($position - 1).addClass('active');
                    $av_image.eq($position - 1).addClass('active');
                    $av_text.eq($position - 1 ).addClass('active');
                    $av_title.eq($position - 1).addClass('active');
                    $av_count.html($position);
                    $(this).trigger('avc:navigate', [$position - 1]);
                }
            });
        }


    /////////////////////////////////////-+++-
    // Quiz
    //

        if ( $('.quiz').length ) {
            var $quiz = $('.quiz'); // there should only be one quiz per page
            var $quiz_questions = $quiz.find('.quiz__question');
            var $quiz_question_labels = $quiz_questions.find('label');
            var $quiz_next_button = $quiz.find('.quiz-question__footer a');
            var $quiz_answer_flag = false; // a flag to see if an answer has been selected
            var $quiz_error_flag = false; // error flag to see if the error message exists or not
            var $quiz_error_message = "<div id='quiz-error' class='error'>Please select an answer.</div>"
            var $question_count = $quiz_questions.length;

            // selects the quiz answer
            $quiz_question_labels.on('keypress click', function(e) {
                // remove the 'is-selected' class from all other answers in this question
                $(this).closest('.quiz__question').find('label').removeClass("is-selected");
                // make this answer selected
                $(this).addClass("is-selected");
                // adjust our flag to tru
                $quiz_answer_flag = true;

                // var button = $(this).closest('.Question__body').siblings(".Question__footer").find('.Question__next');

                // // slide down to the next question
                // $('html,body').animate({scrollTop: $(this).closest('.Question__body').siblings(".Question__footer").find('.Question__next').offset().top - topSpacing},'slow', function() {
                //  // move focus to the next button
                //  button.focus();
                // });
            });

            // progress through quiz questions
            $quiz_next_button.on('keypress click', function(e) {
                e.preventDefault();

                // check to see if an answer has been selected, if so progress to next question
                if ($quiz_answer_flag == true) {

                    // get the question index and add 2
                    var $quiz_index = $(this).closest('.quiz__question').index() +2;

                    // if its not the last question, show the next question
                    if ($quiz_index <= $question_count ) {

                        // show the next question
                        $(this).closest('.quiz__question').next('.quiz__question').addClass("js-active");

                        // slide down to the next question
                        $('html,body').animate({scrollTop: $("#quiz-question-" + $quiz_index).offset().top},'slow');

                        // remove the button
                        $(this).closest('.quiz-question__footer').addClass('js-hidden');

                        // reset the error flag and remove the error message
                        $quiz_error_flag = false;
                        $('#quiz-error').remove();

                        // reset the answer flag
                        $quiz_answer_flag = false;

                    } else {
                        // if it is the last question, submit the quiz
                        $('#quiz').click();
                    }

                } else {


                    // if the error message has not revealed itself yet, inject it
                    if ($quiz_error_flag == false) {
                        $(this).closest('.quiz-question').find('.quiz-question__answers').prepend($quiz_error_message);
                        $quiz_error_flag = true;
                    }
                }
            });
        }

        if ( $('.quiz-results').length ) {

            // triggering the results animation
            var checkScore = function(element) {
                var $score = $(element).attr('data-attr-score');

                if ($score >= 3 && $score <= 4 ) {
                    $(element).addClass("is-middle");
                } else if ($score > 4 ) {
                    $(element).addClass("is-last");
                }
            };

            $(document).ready(function() {
                checkScore('.quiz-results__score--you');
                checkScore('.quiz-results__score--everyone');
            });

            var $userScore = $('.quiz-results__score--you').attr('data-attr-score');
            var $averageScore = $('.quiz-results__score--everyone').attr('data-attr-score');

            var waypoints = $('.quiz-results__score--everyone .quiz-results__score-text').waypoint({
                handler: function(direction) {
                    $('.quiz-results__score--you .quiz-results__score-icon').addClass("score__" + $userScore);
                    $('.quiz-results__score--everyone .quiz-results__score-icon').addClass("score__" + $averageScore);
                },
                offset: '100%'
            });
        }


    /////////////////////////////////////-+++-
    // Poll results
    // 'count up' the poll results number when a user scrolls to it

        var countIt = function(elementer, starter) {

            // grab the number to count up to and turn it into an integer
            var $numberString = $('#' + elementer).html();
            var $numberInt = + $numberString.replace(/,/g, '');

            // create the countup call
            var $numAnim = new CountUp(elementer, 0, $numberInt);

            // make a waypoint event for it
            var waypointCount = $(starter).waypoint({
                handler: function(direction) {
                        $numAnim.start();

                var $percentage = 1 + ($numberInt * .02);
                var $fontsize = 18 + (50 * ($numberInt * .01));
                $('#' + elementer).closest('.pair__stat-number').siblings('.pair__stat-dot').css('transform', 'scale(' + $percentage + ')');
                $('#' + elementer).closest('.pair__stat').css('font-size', $fontsize + 'px');

                },
                offset: 'bottom-in-view'
            });
        }

        // don't call anything unless we're on the poll results page
        if ( $( ".pair__stat" ).length ) {
            countIt("pair__stat1", '.pair__stat');
            countIt("pair__stat2", '.pair__stat');
        }

        /////////////////////////////////////-+++-
        // Time limited share lock/unlock
        //

        if ($('.time-limited-share').length) {

            $('.time-limited-share__unlock').on("click", function (e) {
                var buttonText = $('.time-limited-share__unlock').text();
                e.preventDefault();
                var clicked = $(this);

                // if we are in the pattern library
                if ($('html').hasClass('patternlibrary')) {
                    $('.time-limited-share__unlock').text(buttonText);
                    clicked.closest('.time-limited-share').addClass("js-unlocked");
                } else {

                    // Ajax call.
                    $.getJSON(Drupal.url("time_limited_sharing/generate/" + drupalSettings.nodeId))
                    // Success
                        .done(function (data) {
                            $('.time-limited-share__unlock').text(buttonText);
                            var token = data.token;

                            // update link
                            $('#share-link').val($('#share-link').data('url') + '?unlock=' + token);
                            clicked.closest('.time-limited-share').addClass("js-unlocked");
                        })
                        .fail(function (jqxhr, textStatus, error) {
                            // Error @todo Error message for the user?
                            $('.time-limited-share__unlock').text('Error. Please try again.');
                            var err = textStatus + ", " + error;
                            console.log("Request Failed: " + err);
                        });
                }
            });

            // Copy to clipboard.
            $('.time-limited-share__unlocked-content input').click(function () {
                $('#share-link').select();
                document.execCommand("copy");
            });
          }

    /////////////////////////////////////-+++-
    // Color band adjustments
    // This adjusts the colors of components depending on the order of components
    // On almost all instances this is handled using the CSS adjacent sibling selector,
    // but in the instances below, wrapping markup in Drupal has required the use of javascript.

    if ($('#block-mainpagecontent .page').next().hasClass('filmstrips') &&
        $('#block-mainpagecontent .filmstrips').next().hasClass('big-short-stack')
      ) {
      if($('#block-mainpagecontent').children().last().hasClass('big-short-stack')) {
        $('#block-echo-block-21').addClass('js-gray');
      }
    }

    if ($('#block-mainpagecontent > article .page').next().hasClass('big-short-stack') &&
        $('#block-mainpagecontent > article .big-short-stack').next().hasClass('filmstrips')
      ) {
      if($('#block-mainpagecontent > article').children().last().hasClass('filmstrips')) {
        $('#block-echo-block-21').addClass('js-gray');
      }
    }

    if ($('#block-mainpagecontent .page').next().hasClass('steps') &&
        $('#block-mainpagecontent .steps').next().hasClass('sponsor-thanks') &&
        $('#block-mainpagecontent .sponsor-thanks').next().hasClass('filmstrips') &&
        $('#block-mainpagecontent .filmstrips').next().hasClass('big-short-stack')
      ) {
      if($('#block-mainpagecontent').children().last().hasClass('big-short-stack')) {
        $('#block-echo-block-21').addClass('js-gray');
      }
    }

    if ($('#block-mainpagecontent .page').next().hasClass('partner-carousel') &&
        $('#block-mainpagecontent .partner-carousel').next().hasClass('testimonial-carousel')
      ) {
      if($('#block-mainpagecontent').children().last().hasClass('testimonial-carousel')) {
        $('#block-echo-block-21').addClass('js-gray');
      }
    }

    if ($('#block-mainpagecontent .special-promo').next().hasClass('big-short-stack')) {
      if($('#block-mainpagecontent').children().last().hasClass('big-short-stack')) {
        $('#block-echo-block-21').addClass('js-gray');
      }
    }

    /////////////////////////////////////-+++-
    // Tooltips

    $( document ).ready(function() {
      $('.tooltip').each(function () {
        if ($(this).find('.tooltip__content').is(':off-right')) {
          $(this).addClass('right-edge');
        }
        if ($(this).find('.tooltip__content').is(':off-left')) {
          $(this).addClass('left-edge');
        }
      });
    });

    $(window).resize(function () {
      waitForFinalEvent(function(){
        $('.tooltip').each(function () {
          $(this).removeClass('left-edge right-edge');
          if ($(this).find('.tooltip__content').is(':off-right')) {
            $(this).addClass('right-edge');
          }
          if ($(this).find('.tooltip__content').is(':off-left')) {
            $(this).addClass('left-edge');
          }
      });
      }, 500, "tooltip resizes");
    });

    // School Lookup Functions
    $(document).ready(function() {
      if ($('body.user-school').length) {

        // convertRegion usage:
        // var stateName = convertRegion("TX", "name");
        // var stateAbbr = convertRegion("Texas", "abbr");
        function convertRegion(input, to) {
          var states = [
            ['Alabama', 'AL'],
            ['Alaska', 'AK'],
            ['American Samoa', 'AS'],
            ['Arizona', 'AZ'],
            ['Arkansas', 'AR'],
            ['Armed Forces Americas', 'AA'],
            ['Armed Forces Europe', 'AE'],
            ['Armed Forces Pacific', 'AP'],
            ['California', 'CA'],
            ['Colorado', 'CO'],
            ['Connecticut', 'CT'],
            ['Delaware', 'DE'],
            ['District of Columbia', 'DC'],
            ['Florida', 'FL'],
            ['Georgia', 'GA'],
            ['Guam', 'GU'],
            ['Hawaii', 'HI'],
            ['Idaho', 'ID'],
            ['Illinois', 'IL'],
            ['Indiana', 'IN'],
            ['Iowa', 'IA'],
            ['Kansas', 'KS'],
            ['Kentucky', 'KY'],
            ['Louisiana', 'LA'],
            ['Maine', 'ME'],
            ['Marshall Islands', 'MH'],
            ['Maryland', 'MD'],
            ['Massachusetts', 'MA'],
            ['Michigan', 'MI'],
            ['Minnesota', 'MN'],
            ['Mississippi', 'MS'],
            ['Missouri', 'MO'],
            ['Montana', 'MT'],
            ['Nebraska', 'NE'],
            ['Nevada', 'NV'],
            ['New Hampshire', 'NH'],
            ['New Jersey', 'NJ'],
            ['New Mexico', 'NM'],
            ['New York', 'NY'],
            ['North Carolina', 'NC'],
            ['North Dakota', 'ND'],
            ['Northern Mariana Islands', 'MP'],
            ['Ohio', 'OH'],
            ['Oklahoma', 'OK'],
            ['Oregon', 'OR'],
            ['Pennsylvania', 'PA'],
            ['Puerto Rico', 'PR'],
            ['Rhode Island', 'RI'],
            ['South Carolina', 'SC'],
            ['South Dakota', 'SD'],
            ['Tennessee', 'TN'],
            ['Texas', 'TX'],
            ['United States Virgin Islands', 'VI'],
            ['Utah', 'UT'],
            ['Vermont', 'VT'],
            ['Virginia', 'VA'],
            ['Washington', 'WA'],
            ['West Virginia', 'WV'],
            ['Wisconsin', 'WI'],
            ['Wyoming', 'WY']
          ];

          // Leaving the Canada provinces in here in case they're needed later.
          /*var provinces = [
            ['Alberta', 'AB'],
            ['British Columbia', 'BC'],
            ['Manitoba', 'MB'],
            ['New Brunswick', 'NB'],
            ['Newfoundland', 'NF'],
            ['Northwest Territory', 'NT'],
            ['Nova Scotia', 'NS'],
            ['Nunavut', 'NU'],
            ['Ontario', 'ON'],
            ['Prince Edward Island', 'PE'],
            ['Quebec', 'QC'],
            ['Saskatchewan', 'SK'],
            ['Yukon', 'YT'],
          ];*/
          // var regions = states.concat(provinces);
          var regions = states;

          var i; // Reusable loop variable
          if (to == "abbr") {
            // input = input.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
            for (i = 0; i < regions.length; i++) {
              if (regions[i][0] == input) {
                return (regions[i][1]);
              }
            }
            // if no match:
            return 'Other';
          } else if (to == "name") {
            input = input.toUpperCase();
            for (i = 0; i < regions.length; i++) {
              if (regions[i][1] == input) {
                return (regions[i][0]);
              }
            }
            // if no match:
            return 'Other';
          }
        }

        // Create the divs inside the first and second options for school match
        $school_match = $('.form-item-field-school-match');
        $school_match.first()
          .append('<div id="nces-lookup" class="hidden"></div>' +
            '<div id="nces-loading" class="hidden">Loading...</div>' +
            '<div id="nces-results" class="hidden"></div>')
          .next().append('<div id="nces-manual-entry" class="hidden">');
          // + '<p class="nces-manual-entry-copy">Copy here about not finding school, next steps.</p></div>');


        var $lookup_container = $('#nces-school-lookup-container');
        var $about_you_container = $('#nces-about-you-container');
        var $edit_school_type = $('#edit-field-school-type');

        // alter label for manual match
        $('label[for=edit-field-school-match-0]').html('Or, Enter Your School Info ' +
          '<span class="nces-small-text">(Can&rsquo;t find your school? Tell us your school info here).</span>');

        // detach and move fields into manual section of school match
        var $name = $('#edit-field-school-name-wrapper').detach();
        var $city = $('#edit-field-school-city-wrapper').detach();
        var $zip = $('#edit-field-school-zip-wrapper').detach();
        var $state = $('#edit-field-school-state-wrapper').detach();
        $zip.appendTo('#nces-manual-entry');
        $city.appendTo('#nces-manual-entry');
        $state.appendTo('#nces-manual-entry');
        $name.appendTo('#nces-manual-entry');


        $(document).find('#nces-lookup').html('<div class="nces-error hidden"></div>' +
          '<div class="nces-input">' +
          '<label for="school-zip-lookup" class="form-required">School ZIP or postal code</label>' +
          '<input class="js-text-full text-full form-text" name="school-zip-lookup" id="school-zip-lookup" value="" size="60" maxlength="255" placeholder="">' +
          '<input type="button" class="nces-lookup button button--primary" id="nces-lookup-button" value="Search"/>' +
          '</div>');

        var schoolID = $('#edit-field-school-id-wrapper input').val();
        var schoolName = $('#edit-field-school-name-0-value').val();
        var schoolCity = $('#edit-field-school-city-0-value').val();
        var schoolZip = $('#edit-field-school-zip-0-value').val();
        var schoolStateLong = $('#edit-field-school-state').val();
        var schoolState = convertRegion(schoolStateLong, 'abbr');

        if (schoolName.length) {
          $(document).find('#edit-field-school-match-wrapper').addClass('hidden');

          // we have a school Name, so let's display the data.
          $('#nces-school-lookup-container h2').html('Your School');
          $('#nces-about-you-container h2').html('About You');
          var existingSchool = $('<div id="nces-school-current">' +
          '<span class="nces-name">' + schoolName + '</span>, ' +
          '<span class="nces-citystate">' + schoolCity + ', ' + schoolState + '</span> ' +
          '<span class="nces-zip">' + schoolZip + '</span>' +
          '<div class="nces-change-school"><a href="#" id="nces-change-school-button">Change school</a></div></div>');
          $(document).find('#nces-school-info').prepend(existingSchool);
        }

        var schoolType = $edit_school_type.val();
        if (schoolType != '_none') {
          $about_you_container.removeClass('hidden');
          if (schoolType == 'K-12' || schoolType == 'Higher Ed') {
            $lookup_container.removeClass('hidden');

            if (!schoolName.length) {
              var $selected = $('input[name="field_school_match"]:checked');
              console.log($selected, $selected.val());
              // auto lookup selected
              if ($selected.val() === "1") {
                $(document).find('#nces-lookup,#nces-results').removeClass('hidden');
                $(document).find('#nces-manual-entry').addClass('hidden');
                // manual entry selected
              } else {
                $(document).find('#nces-lookup,#nces-results').addClass('hidden');
                $(document).find('#nces-manual-entry').removeClass('hidden');
              }
            }
            // $('#edit-field-school-match-1').click();
          } else {
            $lookup_container.addClass('hidden');
          }
        }

        $edit_school_type.on('change', function(e) {
          var schoolType = $(this).val();
          if (schoolType != '_none') {
            $about_you_container.removeClass('hidden');
            if (schoolType == 'K-12' || schoolType == 'Higher Ed') {
              $lookup_container.removeClass('hidden');
              $('#edit-field-school-match-1').click();
            } else {
              $lookup_container.addClass('hidden');
            }
          }
        });

        $(document).on('click', '#nces-change-school-button', function(e) {
          $('#nces-school-lookup-container h2').html('School Look Up');
          $('#nces-about-you-container h2').html('Tell Us About You');
          $(document).find('#edit-field-school-match-wrapper').removeClass('hidden');
          $(document).find('#nces-school-current').remove();
          $('#edit-field-school-match-1').click();
        });
        $('#nces-lookup-button').on('click', function(e){
          e.preventDefault();
          // console.log('button click');

          $(this).attr('disabled', true);
          $(this).addClass('disabled');
          $('.nces-error').empty().addClass('hidden');

          var type = $('#edit-field-school-type').val();
          if (type == 'Higher Ed') {
            var schoolType = 'he'
          } else {
            var schoolType = 'k12'
          }

          var zip = $('#school-zip-lookup').val();
          // console.log(zip);
          if (zip.length > 4) {
            // make search
            $(document).find('#nces-loading').removeClass('hidden');
            $(document).find('#nces-results').empty();
            // console.log('loading');
            makeRequest(schoolType, zip);
          } else {
            $('.nces-error').append('<p>Please enter a valid Zip or Postal Code</p>').removeClass('hidden');
            // console.warn('please enter a valid zip');
            $(this).removeClass('disabled');
            $(this).attr('disabled', false);
          }
          // $(this).removeClass('disabled');
          // $(this).attr('disabled', false);
        });

        // prevent enter key from submitting main form when in school lookup
        $(document).on('keypress', '#school-zip-lookup', function(e) {
          if (e.which == 13) {
            e.preventDefault();
            return false;
          }
        });

        $(document).on('change', 'input.nces-school', function(e) {
          var $selected = $(document).find('input.nces-school:checked');
          $('#edit-field-school-id-wrapper input').val($selected.data('nces-id'));
          $('#edit-field-school-name-0-value').val($selected.data('nces-name'));
          $('#edit-field-school-city-0-value').val($selected.data('nces-city'));
          $('#edit-field-school-zip-0-value').val($selected.data('nces-zip'));
          var stateAbbr = $selected.data('nces-state');
          var stateName = convertRegion(stateAbbr, "name");
          $('#edit-field-school-state').val(stateName).trigger("chosen:updated");
        });

        $(document).on('click change', 'input[name=field_school_match]', function(e) {
          var $selected = $('input[name="field_school_match"]:checked');

          // auto lookup selected
          if ($selected.val() === "1") {
            $(document).find('#nces-lookup,#nces-results').removeClass('hidden');
            $(document).find('#nces-manual-entry').addClass('hidden');

          // manual entry selected
          } else {
            $(document).find('#nces-lookup,#nces-results').addClass('hidden');
            $(document).find('#nces-manual-entry').removeClass('hidden');
            // if user toggles the auto/manual switch we need to clear the data.
            if (e.type === 'change') {
              $('#edit-field-school-id-wrapper input').val('');
              $('#edit-field-school-name-0-value').val('');
              $('#edit-field-school-city-0-value').val('');
              $('#edit-field-school-zip-0-value').val('');
              $('#edit-field-school-state').val('_none').trigger("chosen:updated");
            }
          }
        });

        // $(document).on('change', 'label.nces-radio', function(e) {
        //   console.log('label click');
        // });
        var makeRequest = function(type, zip) {
          if (type.length && zip.length) {
            var request = $.ajax({
              url: '/school/' + type + '/' + zip,
              data: {},
              dataType: 'json',
              timeout: 15000,
              success: function (data, textStatus, jqXHR) {
                var schools = '<ul class="nces-schools">';
                for (var i = 0; i < data.length; i++) {
                  var obj = data[i];
                  var school = '<li data-nces-id="' + obj.instUid + '" class="js-form-type-radio">' +
                    '<input type="radio" class="radio nces-school" name="nces-school" value="' + obj.instUid +
                    '" id="nces-radio-' + obj.instUid +
                    '" data-nces-id="' + obj.instUid +
                    '" data-nces-name="' + obj.institutionNameProper +
                    '" data-nces-city="' + obj.mailingCityProper +
                    '" data-nces-state="' + obj.mailingState +
                    '" data-nces-zip="' + obj.mailingZip5 +
                    '"> ';
                  school += '<label for="nces-radio-' + obj.instUid + '" class="option nces-radio">';
                  school += '<span class="nces-name">' + obj.institutionNameProper + '</span>, ';
                  school += '<span class="nces-citystate">' + obj.mailingCityProper + ', ' + obj.mailingState + '</span> ';
                  school += '<span class="nces-zip">' + obj.mailingZip5 + '</span>';
                  school += '</label>';
                  school += '</li>';
                  schools += school;
                }
                schools += '</ul>';
                // $('#edit-field-school-match--wrapper').append(schools);
                $(document).find('#nces-results').html(schools);
                // $('.form-item-field-school-match').first().append(schools);
                // '<pre>' + JSON.stringify(data) + '</pre>');
                // console.log(data);
                $(document).find('#nces-loading').addClass('hidden');
                $('#nces-lookup-button').removeClass('disabled').attr('disabled', false);
              },
              error: function (jqXHR, textStatus, errorThrown) {
                // request timed out (invalid zip) or no results found.
                // console.log('ajax error: ' + errorThrown);
                $(document).find('#nces-loading').addClass('hidden');
                $('#nces-lookup-button').removeClass('disabled').attr('disabled', false);
                $(document).find('#nces-results').html('<ul><li>No Results Found</li></ul>');
                // $('.form-item-field-school-match').first().append('<ul><li>No Results Found</li></ul>');
              }
            });
          }
        }
      }
    });

    /////////////////////////////////////-+++-
    // Pikaday - Datepicker
  Drupal.behaviors.pikadayPicker = {
    attach: function(context, settings) {
      // $(".pikaday").pikaday();
      var today = new Date();
      var pickers = $(".pikaday").map(function (i, item) {
        return new Pikaday({
          field: item,
          format: 'MM/DD/YYYY',
          theme: "date-picker--modal",
          minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
          i18n: { // change weekdaysShort to match Airbnb model
            previousMonth: 'Previous Month',
            nextMonth: 'Next Month',
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            weekdaysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
          }
        });
      })
    }
  };

  /////////////////////////////////////-+++-
  // Location exposed filter on the Event landing page
  Drupal.behaviors.locationSelect = {
    attach: function(context, settings) {
      $(".filter-bar__location label").click(function(){
        var id = $(this).data('value');

        // Remove any existing checkboxes.
        $(this).closest('ul').find('.filter-bar__location-text').removeClass('checked');

        // Add checkbox for item selected.
        $(this).find('.filter-bar__location-text').addClass('checked');

        // Store the value in the form.
        $('input#filter-location').val(id);
        $('select[name="location"] option[value="' + id + '"]').attr('selected', 'selected').trigger("change");
      });

      // Onload set the default checkbox.
      var id = $('input[name="location"]').val();
      $('label[data-value="' + id + '"] .filter-bar__location-text').addClass('checked');
    }
  };

  /////////////////////////////////////-+++-
  // Online event exposed filter on the Event landing page
  Drupal.behaviors.eventsOnlineCheckbox = {
    attach: function(context, settings) {
      $(".filter-bar__online-label").click(function() {
        var newValue = '';
        var thisInput = $(this).find('input');
        var value = thisInput.val();
        if (value == 1) {
          thisInput.removeAttr("checked");
          newValue = 'All';
          thisInput.val(newValue);
        } else {
          thisInput.attr("checked", "checked");
          newValue = 1;
          thisInput.val(newValue);
        }
        $('select[name="online"] option[value="' + newValue + '"]').attr('selected', 'selected').trigger("change");
      })
    }
  };

  /////////////////////////////////////-+++-
  // Dropbutton open/close functionality
  Drupal.behaviors.dropButton = {
    attach: function (context, settings) {

      if ($('.dropbutton').length) {
        $(once('drop-btn-click', '.dropbutton__trigger')).click(function (e) {
          var $dropbutton_trigger = $(this);
          var $dropbutton = $dropbutton_trigger.parent();
          var $dropbutton_content = $dropbutton.find('.dropbutton__content');

          $dropbutton.toggleClass('js-open dropdown-is-open');

          if (!$dropbutton.hasClass('dropbutton--no-slide')) {
            $dropbutton_content.slideToggle('fast');
          }
          else {
            $dropbutton_content.slideToggle({duration: 0});
          }
        });

        // close the dropdown on outside click
        $(once('drop-body-click', 'body')).click(function (e) {
          if (!$(e.target).closest('.dropbutton').length) {
            var $openDropbuttons = $('.js-open.dropdown-is-open');
            var $openDropbuttonsContent = $openDropbuttons.find('.dropbutton__content');

            // remove classes
            $openDropbuttons.toggleClass('js-open dropdown-is-open');

            // close dropdown
            $openDropbuttonsContent.slideToggle({duration: 0});
          }
        });
      }
    }
  };


}(jQuery, Drupal, drupalSettings));
